/**
 * Application configuration.
 *
 * BRAND_SKIN selects everything: CSS skin, asset paths, brand word.
 * Components never reference a skin directly — they read from brand.ts
 * which reads from here.
 */

export type BrandSkin = 'orbital' | 'monarch';

export const config = {
  // Kratos public URL - proxied through Vite in dev, nginx in production
  kratosPublicUrl: import.meta.env.VITE_KRATOS_PUBLIC_URL || '/api/kratos',

  // Gateway URL for organization operations
  gatewayUrl: import.meta.env.VITE_GATEWAY_URL || '/api/gateway',

  // Return URL after successful auth
  defaultReturnUrl: import.meta.env.VITE_DEFAULT_RETURN_URL || '/settings',

  // Skin selection — controls CSS, assets, brand word (§6)
  brandSkin: (import.meta.env.VITE_BRAND_SKIN || 'orbital') as BrandSkin,

  // App name — bare product name in-app per §3.8
  appName: import.meta.env.VITE_APP_NAME || 'Passport',

  // Brand word — "Orbital" or "Monarch", set by skin
  brandWord: import.meta.env.VITE_BRAND_WORD ||
    ((import.meta.env.VITE_BRAND_SKIN || 'orbital') === 'monarch' ? 'Monarch' : 'Orbital'),

  // Base domain for cross-service redirect inference
  baseDomain: import.meta.env.VITE_BASE_DOMAIN || 'epy.digital',
};
